import { TypePolicy } from '@apollo/client'
export const workspaceTogglesPolicy = {
    WorkspaceToggle: {
        keyFields: ['id', 'baseElementId'],
        fields: {
            notes: {
                read: (_) => {
                    return true
                },
            },
            shared: {
                read: (_, { }) => {
                    return true
                },
            },
            properties: {
                read: (_) => {
                    return true
                },
            },
        },
    } as TypePolicy,
}
